<div>
    <mat-drawer-container [hasBackdrop]="false" autosize style="height: calc(100vh - 50px); width:100%">
        <mat-drawer #drawer mode="side" opened>
            <div class="clearfix mt-1 mr-1"><button mat-stroked-button (click)="openNewSearchForm()"
                    class="float-right">
                    <mat-icon>add</mat-icon> New
                </button>
            </div>
            <div>
                <div class="input-group-sm mt-2 input-group col-12">
                    <input class="form-control" type="search" (search)="applyFilter($event)"
                        (keyup)="applyFilter($event)" placeholder="Filter">
                </div>
            </div>
            <div class="m-2 text-center" *ngIf="noSearchForms">
                No Search Forms to view
            </div>
            <mat-nav-list *ngIf="!noSearchForms" style="padding: 0 0;">
                <div *ngFor="let searchForm of navBarForms">
                    <a  *ngIf="searchForm.id != 13" style="height: 30px; padding:0 0;" mat-list-item
                        (click)="getSearchForm(searchForm.id)" [class.selected]="selectedForm === searchForm">
                        <button style="height: 30px; font-size: 11pt;" mat-button class="form-names">
                            {{searchForm.name}}</button>
                    </a>
                </div>
            </mat-nav-list>
        </mat-drawer>
        <mat-drawer-content style="margin-right: 0; padding:1">
            <div>
                <div id="searchResults">
                    <div class="card p-2 m-2" *ngIf="!openForm &&!successMessage">
                        <div class="card-body p-2"><strong>To edit a Search Template:</strong><br> 1.Please select a
                            Search Template you wish to edit and update.<br> 2.Fill in the data to the appropriate
                            fields and update.
                            <br>
                            <br><br>
                            <strong>To create a New Search Template:</strong><br> 1.Click on "+New".<br> 2.Fill in the
                            appropriate data in their respective fields and save.
                        </div>
                    </div>

                    <div class="card p-2 m-2" *ngIf="openForm && allCategories.results">
                        <div class="sticky-top">
                            <div *ngIf="updateSearchForm" class="Tabletitle">
                                Search Template - {{searchFormName}}
                                <mat-icon *ngIf="isAdmin" class="delete-icon" style="float: right;"
                                    (click)="deleteSearchFormHandler()" title="Delete Search Form">delete
                                </mat-icon>
                            </div>
                        </div>
                        <div *ngIf="createSearchForm" class="sticky-top">
                            <div class="Tabletitle">Create Search Template</div>
                        </div>
                        <div class="card-body">
                            <form [formGroup]="searchForm">
                                <div class="input-group-sm mb-3 input-group col-12">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text form-label-105">Name</span>
                                    </div>
                                    <input class="form-control" type="text" formControlName="name">
                                </div>

                                <div class="input-group-sm mb-3 input-group col-12">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text form-label-105">Categories</span>
                                    </div>
                                    <mat-select [(ngModel)]="categories"
                                        (selectionChange)="getDisplayListData(categories)" (ngModelChange)="categories"
                                        multiple formControlName="categories" class="form-control">
                                        <mat-option>
                                            <ngx-mat-select-search [(ngModel)]="searchCtrl"
                                                [placeholderLabel]="'Search...'" [noEntriesFoundLabel]="'Not found'"
                                                name="search" [ngModelOptions]="{standalone: true}">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option
                                            *ngFor="let category of allCategories.results |stringFilter:searchCtrl:'name'"
                                            [value]="category.id">
                                            {{category.name}}
                                        </mat-option>
                                    </mat-select>
                                </div>

                                <div class="input-group-sm mb-3 input-group col-12">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text form-label-105">Display List</span>
                                    </div>
                                    <mat-select multiple formControlName="display_list" class="form-control">
                                        <span *ngFor="let displayData of selectedFormDisplayList">
                                            <span
                                                *ngIf="displayData.name!='Title' && displayData.name!='Creation Date' && displayData.name!='Created By'">
                                                <mat-option [value]="displayData.value">
                                                    {{displayData.name}}
                                                </mat-option>
                                            </span>
                                        </span>
                                    </mat-select>
                                </div>

                                <div class="card p-2 m-3 mb-2">
                                    <div formArrayName="form">
                                        <div class="form-group row">
                                            <span class="form-group ml-3 form-label-105">Form</span>
                                            <div class="col mb-2">
                                                <button mat-stroked-button class="float-right" title="Add Form"
                                                    (click)="addNewForm()">
                                                    <mat-icon>add</mat-icon>Add Form
                                                </button>
                                            </div>
                                        </div>
                                        <div class="row" *ngIf="formArray.controls.length > 1">
                                            <div class="col-3">
                                                <span class="form-group ml-3 form-label-105">Connecting
                                                    Operator:</span>
                                            </div>
                                            <div class="col-9">
                                                <input type="radio" id="AND" name="operator" value="AND"
                                                    [ngModelOptions]="{standalone: true}"
                                                    [(ngModel)]="connectingOperator"
                                                    (change)="attributeChangeHandler()">
                                                <label for="AND">&nbsp;AND</label>&nbsp;&nbsp;
                                                <input type="radio" id="OR" name="operator" value="OR"
                                                    [ngModelOptions]="{standalone: true}"
                                                    [(ngModel)]="connectingOperator"
                                                    (change)="attributeChangeHandler()">
                                                <label for="OR">&nbsp;OR</label>
                                            </div>
                                        </div>

                                        <div class="row card-body">
                                            <table
                                                class="table table-bordered table-responsive-md table-striped text-center"
                                                aria-describedby="search-forms">
                                                <tr>
                                                    <th *ngFor="let column of formColumns" id="{{column}}"
                                                        class="table-header">
                                                        {{column}}
                                                    </th>
                                                    <th id="remove-column" class="table-header">
                                                        Action
                                                    </th>
                                                </tr>
                                                <tr class="table-row"
                                                    *ngFor="let item of getForm(searchForm); let i=index"
                                                    [formGroupName]="i">
                                                    <td style="width: fit-content;">
                                                        <input class="form-control" type="text" formControlName="label">
                                                    </td>
                                                    <td style="width: fit-content;">
                                                        <input class="form-control" type="text"
                                                            formControlName="helpText">
                                                    </td>
                                                    <td style="width: fit-content;">
                                                        <mat-select formControlName="operator" class="form-control">
                                                            <mat-option *ngFor="let operator of listOfOperators"
                                                                [value]="operator">
                                                                {{operator}}</mat-option>
                                                        </mat-select>
                                                    </td>
                                                    <td style="width: fit-content;">
                                                        <mat-slide-toggle class="pl-2 pr-2 pt-1"
                                                            formControlName="required">
                                                        </mat-slide-toggle>
                                                    </td>
                                                    <td style="width: fit-content;">
                                                        <mat-select formControlName="UIControl" class="form-control">
                                                            <mat-option *ngFor="let UIControl of listOfUIControl"
                                                                [value]="UIControl">
                                                                {{UIControl}}</mat-option>
                                                        </mat-select>
                                                    </td>
                                                    <td style="width: fit-content;">
                                                        <mat-select formControlName="attribute" class="form-control"
                                                            (selectionChange)="attributeChangeHandler()">
                                                            <mat-option
                                                                *ngFor="let attribute of selectedFormDisplayList"
                                                                [value]="attribute.value">
                                                                {{attribute.name}}</mat-option>
                                                        </mat-select>
                                                    </td>

                                                    <td>
                                                        <mat-icon (click)="deleteForm(i)"
                                                            *ngIf="formArray.controls.length > 1">delete
                                                        </mat-icon>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                        <!-- <div *ngFor="let item of getForm(searchForm); let i=index" [formGroupName]="i">
                                            <div class="row">
                                                <div class="col-11">
                                                    <div class="card p-2 mb-2">
                                                        <div class="input-group row">
                                                            <div class="col-4">
                                                                <div class="input-group-sm mb-3 input-group col">
                                                                    <div class="input-group-prepend">
                                                                        <span class="input-group-text">Search Input
                                                                            Label</span>
                                                                    </div>
                                                                    <input class="form-control" type="text"
                                                                        formControlName="label">
                                                                </div>
                                                            </div>

                                                            <div class="col-4">
                                                                <div class="input-group-sm mb-3 input-group col">
                                                                    <div class="input-group-prepend">
                                                                        <span class="input-group-text">Help
                                                                            Text/Value</span>
                                                                    </div>
                                                                    <input class="form-control" type="text"
                                                                        formControlName="helpText">
                                                                </div>
                                                            </div>

                                                            <div class="col-4">
                                                                <div class="input-group-sm mb-3 input-group col">
                                                                    <div class="input-group-prepend">
                                                                        <span class="input-group-text">Operator</span>
                                                                    </div>
                                                                    <mat-select formControlName="operator"
                                                                        class="form-control">
                                                                        <mat-option
                                                                            *ngFor="let operator of listOfOperators"
                                                                            [value]="operator">
                                                                            {{operator}}</mat-option>
                                                                    </mat-select>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="input-group row">
                                                            <div class="col-4">
                                                                <div class="input-group-sm mb-3 input-group col">
                                                                    <div class="input-group-prepend">
                                                                        <span class="input-group-text">Required</span>
                                                                    </div>
                                                                    <mat-slide-toggle class="pl-2 pr-2 pt-1"
                                                                        formControlName="required">
                                                                    </mat-slide-toggle>
                                                                </div>
                                                            </div>

                                                            <div class="col-4">
                                                                <div class="input-group-sm mb-3 input-group col">
                                                                    <div class="input-group-prepend">
                                                                        <span class="input-group-text">UI
                                                                            Control</span>
                                                                    </div>
                                                                    <mat-select formControlName="UIControl"
                                                                        class="form-control">
                                                                        <mat-option
                                                                            *ngFor="let UIControl of listOfUIControl"
                                                                            [value]="UIControl">
                                                                            {{UIControl}}</mat-option>
                                                                    </mat-select>
                                                                </div>
                                                            </div>

                                                            <div class="col-4">
                                                                <div class="input-group-sm mb-3 input-group col">
                                                                    <div class="input-group-prepend">
                                                                        <span class="input-group-text">Attribute</span>
                                                                    </div>
                                                                    <mat-select formControlName="attribute"
                                                                        class="form-control"
                                                                        (selectionChange)="attributeChangeHandler()">
                                                                        <mat-option
                                                                            *ngFor="let attribute of selectedFormDisplayList"
                                                                            [value]="attribute.value">
                                                                            {{attribute.name}}</mat-option>
                                                                    </mat-select>
                                                                </div>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>
                                                <div class="col-1">
                                                    <mat-icon (click)="deleteForm(i)"
                                                        *ngIf="formArray.controls.length > 1">delete
                                                    </mat-icon>
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>
                                </div>

                                <div class="input-group-sm mb-3 input-group col-12">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text form-label-105">Description</span>
                                    </div>
                                    <textarea class="form-control" type="text" formControlName="description"></textarea>
                                </div>

                                <div class="input-group-sm mb-3 input-group col-12">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text form-label-105">Search Criteria</span>
                                    </div>
                                    <textarea class="form-control" type="text"
                                        formControlName="search_criteria"></textarea>
                                </div>

                                <button *ngIf="createSearchForm" mat-raised-button class="actionButton"
                                    [disabled]="!searchForm.valid" type="submit"
                                    (click)="saveSearchForm()">{{button}}</button>
                                <button *ngIf="updateSearchForm" mat-raised-button class="actionButton"
                                    [disabled]="!searchForm.valid" type="submit"
                                    (click)="updateSearch()">{{button}}</button>
                            </form>
                        </div>
                    </div>

                    <div class="card" *ngIf="successMessage && !openForm">
                        <div class="card-body">
                            <div style="text-align: center;" [innerHtml]="message"></div>
                            <div>
                                <button mat-raised-button class="backButton" (click)="back()">Back</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-drawer-content>
    </mat-drawer-container>
</div>